import React from 'react';
import { Locale } from '../../../../localization/LocalizationKeys';
import DateDisplay from '../../../components/Badge/DateDisplay';
import { personFieldConfig } from './utils/personFieldsUtils';

export const personImportedFieldConfig = personFieldConfig(
  'imported',
  ['ct'],
  ({ localization }) => ({
    title: localization.formatMessage(Locale.Attribute.Import_date),
    additionalTableConfig: {
      width: 125
    },
    render: (record) => <DateDisplay>{record?.ct}</DateDisplay>,
  })
);

